import { createSelector } from "reselect";
import { CommerceToolsApi } from "@grandvisionhq/commercetools";
import { Selectors } from "@grandvisionhq/configurator";
import { uninitState, FeatureToggleSelectors } from "@grandvisionhq/state";
import { isNewPrescriptionAndUpload } from "../../../../utils/utils/is-new-prescription-upload.js";
import { getLensTypes as getLensTypes$1, getPackages as getPackages$1, getLensAddOns } from "../../../bundles/state/bundles/selectors.js";
import { getPrescriptionType as getPrescriptionType$1, getPdUploadValidationRequirement as getPdUploadValidationRequirement$1, getSelectedLensType as getSelectedLensType$1, getSelectedPackage as getSelectedPackage$1, getSelectedAddOn as getSelectedAddOn$1, getPrescription as getPrescription$1, getAdditionalPrescriptionInfoFormState as getAdditionalPrescriptionInfoFormState$1, getManualPrescriptionValidationState as getManualPrescriptionValidationState$1, getPrescriptionUploadValidationState, getVerificationAllowed as getVerificationAllowed$1 } from "../../../configurations/state/configurations/selectors.js";
import { getLensTypeSku, getPackageSku } from "../../../configurations/state/configurations/selectors.internal.js";
import { convertToFrameInfo } from "../../../state/helpers.js";
import { getFrameImage as getFrameImage$1 } from "../../../products/state/products/selectors.js";
import { getFrames } from "../../../products/state/products/selectors.internal.js";
import { configuratorIdProp } from "../../../state/selectors.internal.js";
import { getConfigurator } from "./selectors.internal.js";
const getIsExtraValidationStepEnabled = createSelector(
  getConfigurator,
  (c) => c.isExtraValidationStepEnabled
);
const getRxEntryTypes = createSelector(
  getConfigurator,
  (c) => c.rxEntryTypes
);
const getBookAppointmentRoute = createSelector(
  getConfigurator,
  (c) => c.bookAppointmentRoute
);
const getFrameSku = createSelector(getConfigurator, (c) => c?.frameSku);
const getFrameImage = createSelector(
  getFrameSku,
  (s) => s,
  (_, props) => props,
  (frameSku, state, frameImageProps) => {
    if (!frameSku) {
      return void 0;
    }
    const { width } = frameImageProps;
    return getFrameImage$1(state, {
      frameSku,
      width
    });
  }
);
const getSelectedFrame = createSelector(
  getFrameSku,
  getFrames,
  (frameSku, frames) => {
    if (!frameSku) {
      return void 0;
    }
    const frame = frames[frameSku];
    if (!frame) {
      return void 0;
    }
    return convertToFrameInfo(frame, frameSku);
  }
);
const getSelectedFrameProductType = createSelector(
  getFrameSku,
  getFrames,
  (frameSku, frames) => {
    if (!frameSku) {
      return;
    }
    const frame = frames[frameSku];
    if (!frame) {
      return;
    }
    return frame.productType.obj?.name;
  }
);
const getPrescriptionType = createSelector(
  getFrameSku,
  (s) => s,
  (frameSku, state) => {
    if (!frameSku) {
      return void 0;
    }
    return getPrescriptionType$1(state, { frameSku });
  }
);
const getPdUploadValidationRequirement = createSelector(
  getFrameSku,
  (s) => s,
  (frameSku, state) => {
    if (!frameSku) {
      return void 0;
    }
    return getPdUploadValidationRequirement$1(state, { frameSku });
  }
);
const getSelectedLensType = createSelector(
  getFrameSku,
  (s) => s,
  (frameSku, state) => {
    if (!frameSku) {
      return void 0;
    }
    return getSelectedLensType$1(state, { frameSku });
  }
);
const getLensTypes = createSelector(
  getFrameSku,
  (s) => s,
  (frameSku, state) => {
    if (!frameSku) {
      return uninitState();
    }
    return getLensTypes$1(state, { frameSku });
  }
);
const getSelectedPackage = createSelector(
  getFrameSku,
  (s) => s,
  (frameSku, state) => {
    if (!frameSku) {
      return void 0;
    }
    return getSelectedPackage$1(state, { frameSku });
  }
);
const getPackages = createSelector(
  getFrameSku,
  (s) => s,
  (frameSku, state) => {
    if (!frameSku) {
      return uninitState();
    }
    const lensTypeSku = getLensTypeSku(state, { frameSku });
    if (!lensTypeSku) {
      return uninitState();
    }
    return getPackages$1(state, { lensTypeSku });
  }
);
const getSelectedAddOn = createSelector(
  getFrameSku,
  (s) => s,
  (frameSku, state) => {
    if (!frameSku) {
      return void 0;
    }
    return getSelectedAddOn$1(state, { frameSku });
  }
);
const getAddOns = createSelector(
  getFrameSku,
  (s) => s,
  (frameSku, state) => {
    if (!frameSku) {
      return uninitState();
    }
    const packageSku = getPackageSku(state, { frameSku });
    const lensTypeSku = getLensTypeSku(state, { frameSku });
    if (!lensTypeSku || !packageSku) {
      return uninitState();
    }
    return getLensAddOns(state, { packageSku });
  }
);
const getPrescription = createSelector(
  getFrameSku,
  (s) => s,
  (frameSku, state) => {
    if (!frameSku) {
      return uninitState();
    }
    const lensTypeSku = getLensTypeSku(state, { frameSku });
    if (!lensTypeSku) {
      return uninitState();
    }
    return getPrescription$1(state, {
      frameSku,
      lensTypeSku
    });
  }
);
const getAdditionalPrescriptionInfoFormState = createSelector(
  getFrameSku,
  (s) => s,
  (frameSku, state) => {
    if (!frameSku) {
      return {};
    }
    return getAdditionalPrescriptionInfoFormState$1(state, { frameSku });
  }
);
const getManualPrescriptionValidationState = createSelector(
  getFrameSku,
  (s) => s,
  (frameSku, state) => {
    if (!frameSku) {
      return void 0;
    }
    const lensTypeSku = getLensTypeSku(state, { frameSku });
    if (!lensTypeSku) {
      return void 0;
    }
    return getManualPrescriptionValidationState$1(state, {
      frameSku,
      lensTypeSku
    });
  }
);
const getIsPrescriptionUploadStepValid = createSelector(
  getFrameSku,
  getPrescriptionType,
  (s) => s,
  (frameSku, prescriptionType, state) => {
    if (!frameSku) {
      return void 0;
    }
    if (CommerceToolsApi.isPrescriptionFile(prescriptionType) || isNewPrescriptionAndUpload(prescriptionType)) {
      return getPrescriptionUploadValidationState(state, { frameSku })?.isValid;
    }
    return void 0;
  }
);
const getIsPrescriptionFormStepValid = createSelector(
  getFrameSku,
  getPrescriptionType,
  (s) => s,
  (frameSku, prescriptionType, state) => {
    if (!frameSku) {
      return void 0;
    }
    if (CommerceToolsApi.isNewPrescription(prescriptionType) || isNewPrescriptionAndUpload(prescriptionType)) {
      return getManualPrescriptionValidationState(state)?.isValid;
    }
    return void 0;
  }
);
const hasVisitedStepPrescription = createSelector(
  (s) => s,
  configuratorIdProp,
  (s, id) => Selectors.hasVisitedStep(s, { id, stepName: "prescription" })
);
const hasVisitedStepLensPackage = createSelector(
  (s) => s,
  configuratorIdProp,
  (s, id) => Selectors.hasVisitedStep(s, { id, stepName: "lensPackage" })
);
const hasVisitedStepAddOn = createSelector(
  (s) => s,
  configuratorIdProp,
  (s, id) => Selectors.hasVisitedStep(s, { id, stepName: "lensAddOn" })
);
const getBundleMinimumSupplement = createSelector(
  FeatureToggleSelectors.getFeatureToggles,
  getSelectedLensType,
  getSelectedPackage,
  getSelectedAddOn,
  hasVisitedStepLensPackage,
  hasVisitedStepAddOn,
  (featureToggles, lensType, lensPackage, selectedAddOn, hasVisitedStepLensPackage2, hasVisitedStepAddOn2) => {
    if (!featureToggles?.isConfiguratorRxPriceFromEnabled) {
      return void 0;
    }
    if (hasVisitedStepAddOn2 && selectedAddOn) {
      return void 0;
    }
    if (hasVisitedStepLensPackage2) {
      if (lensPackage?.areAddOnsOptional) {
        return void 0;
      }
      return lensPackage?.minimumSupplement ?? void 0;
    }
    return lensType?.minimumSupplement ?? void 0;
  }
);
const getBundlePrice = createSelector(
  getSelectedFrame,
  getSelectedLensType,
  getSelectedPackage,
  hasVisitedStepLensPackage,
  getSelectedAddOn,
  hasVisitedStepAddOn,
  getBundleMinimumSupplement,
  (frame, lensType, lensPackage, hasVisitedStepLensPackage2, addOn, hasVisitedStepAddOn2, bundleMinimumSupplement) => {
    if (!frame || !frame.price) {
      return void 0;
    }
    const bundlePrices = [
      frame.price.originalPrice,
      lensType?.price?.originalPrice ?? 0,
      hasVisitedStepLensPackage2 ? lensPackage?.price?.originalPrice ?? 0 : 0,
      hasVisitedStepAddOn2 ? addOn?.price?.originalPrice ?? 0 : 0,
      bundleMinimumSupplement?.originalPrice ?? 0
    ];
    const originalPrice = bundlePrices.reduce((sum, current) => sum + current, 0);
    const hasDiscounts = [
      frame.price.discountedPrice,
      lensType?.price?.discountedPrice,
      hasVisitedStepLensPackage2 && lensPackage?.price?.discountedPrice,
      hasVisitedStepAddOn2 && addOn?.price?.discountedPrice,
      bundleMinimumSupplement?.discountedPrice
    ].filter((p) => typeof p === "number" && !isNaN(p)).length > 0;
    const bundlePricesDiscounted = hasDiscounts ? [
      frame.price.discountedPrice ?? frame.price.originalPrice ?? 0,
      lensType?.price?.discountedPrice ?? lensType?.price?.originalPrice ?? 0,
      hasVisitedStepLensPackage2 ? lensPackage?.price?.discountedPrice ?? lensPackage?.price?.originalPrice ?? 0 : 0,
      hasVisitedStepAddOn2 ? addOn?.price?.discountedPrice ?? addOn?.price?.originalPrice ?? 0 : 0,
      bundleMinimumSupplement?.discountedPrice ?? bundleMinimumSupplement?.originalPrice ?? 0
    ] : [];
    const discountedPrice = hasDiscounts ? bundlePricesDiscounted.reduce((sum, current) => sum + current, 0) : void 0;
    return {
      originalPrice,
      discountedPrice,
      currency: frame.price.currency
    };
  }
);
const getVerificationAllowed = createSelector(
  getFrameSku,
  (s) => s,
  (frameSku, state) => {
    if (!frameSku) {
      return void 0;
    }
    return getVerificationAllowed$1(state, { frameSku });
  }
);
const getAreAddOnsOptional = createSelector(
  getSelectedPackage,
  (p) => p?.areAddOnsOptional ?? true
);
export {
  getAddOns,
  getAdditionalPrescriptionInfoFormState,
  getAreAddOnsOptional,
  getBookAppointmentRoute,
  getBundleMinimumSupplement,
  getBundlePrice,
  getFrameImage,
  getFrameSku,
  getIsExtraValidationStepEnabled,
  getIsPrescriptionFormStepValid,
  getIsPrescriptionUploadStepValid,
  getLensTypes,
  getManualPrescriptionValidationState,
  getPackages,
  getPdUploadValidationRequirement,
  getPrescription,
  getPrescriptionType,
  getRxEntryTypes,
  getSelectedAddOn,
  getSelectedFrame,
  getSelectedFrameProductType,
  getSelectedLensType,
  getSelectedPackage,
  getVerificationAllowed,
  hasVisitedStepAddOn,
  hasVisitedStepLensPackage,
  hasVisitedStepPrescription
};
//# sourceMappingURL=selectors.js.map
